module.exports = __webpack_public_path__ + "img/valen-toons.8d1bfcff.jpg";